module.exports = __webpack_public_path__ + "static/media/password.b2ac4f9f.svg";